import type { BrowserOptions } from "@sentry/browser";

const PII_KEY_DENYLIST = ["forwarded", "-ip", "remote-", "via", "-user"];

/**
 * Sentry options shared by every storefront's `Sentry.init`.
 *
 * SDK v11 collects visitor IP addresses, cookies, headers and bodies unless
 * told otherwise, and attaches synthetic stack traces that regroup issues.
 * These pin the v10 behaviour so shopper data only reaches Sentry after an
 * explicit privacy decision.
 */
export const sentryBaseOptions = {
    attachStacktrace: false,
    dataCollection: {
        userInfo: false,
        cookies: false,
        httpHeaders: {
            request: { deny: PII_KEY_DENYLIST },
            response: { deny: PII_KEY_DENYLIST },
        },
        httpBodies: [],
        urlQueryParams: { deny: PII_KEY_DENYLIST },
        genAI: { inputs: false, outputs: false },
        databaseQueryData: false,
        queues: false,
        graphQL: { document: false, variables: false },
    },
} satisfies BrowserOptions;
